<template>
  <div class="setting" v-if="isPlayer">
    <el-popover
      placement="bottom-end"
      width="324"
      trigger="click"
      popper-class="anonymous-call-calculate"
    >
      <div class="content">
        <div class="item">
          <div class="label">本週共接通</div>
          <div class="value">{{ weekTime }}&nbsp;分鐘</div>
        </div>
        <div class="item">
          <div class="label">總累計接通</div>
          <div class="value">{{ allTime }}&nbsp;分鐘</div>
        </div>
        <div class="item">
          <div class="label">本週通話收禮</div>
          <div class="value">{{ weekGift }}&nbsp;鑽</div>
        </div>
        <div class="item">
          <div class="label">總累計收禮</div>
          <div class="value">{{ allGift }}&nbsp;鑽</div>
        </div>
      </div>
      <img
        class="icon-setting"
        src="./images/icon-setting.png"
        slot="reference"
      />
    </el-popover>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Calculate',
  props: {},
  data() {
    return {
      weekTime: 0,
      allTime: 0,
      weekGift: 0,
      allGift: 0
    };
  },
  watch: {},
  computed: {
    ...mapGetters(['userInfo']),
    isPlayer() {
      return this.userInfo && this.userInfo.userKind === 'Player';
    }
  },
  methods: {
    async getDetail() {
      const { data } = await this.$http.get('anonymous/getCount');
      if(data) {
        this.allGift = data.amount;
        this.weekGift = data.amountWeek
        this.allTime = data.minutes;
        this.weekTime = data.minutesWeek
      }
    }
  },
  created() {
    this.getDetail()
  }
};
</script>
<style lang="scss" scoped>
.setting {
  /deep/ .el-popover__reference-wrapper {
    display: flex;
    align-items: center;
  }
}
.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.14);
  font-size: 16px;
  &:last-child {
    border: none;
  }

  .label {
    color: rgba(255, 255, 255, 0.55);
  }
  .value {
    color: rgba(255, 255, 255, 0.77);
  }
}
.icon-setting {
  width: 17px;
  cursor: pointer;
}
</style>
<style lang="scss">
.anonymous-call-calculate {
  &.el-popper {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.14);
    .popper__arrow {
      border-bottom-color: rgba(255, 255, 255, 0.14);
      &:after {
        top: 0;
        border-bottom-color: rgba(255, 255, 255, 0.14);
      }
    }
  }
}
</style>
